import React, { useState, useEffect, useRef } from "react";
import "../../App.css";

function ServicesLandingPage({ handleNavClick }) {
  return (
    <>
      {/* Services Header */}
      <div className="services-header">
        <div className="section__container">
          <h2 className="section__title">Industry Verticals</h2>
          {/*<p className="section__intro">
            We provide a wide range of geospatial services including consulting, implementation, and support.
          </p>*/}
        </div>
      </div>
      <div className="industry_bg">
        {/* Industry Verticals Grid */}
        <section className="industry-verticals-page">

          <h3 className="products-landing__title">Our Industry Solutions</h3>
          <p className="products-landing-discription">
            We provide end-to-end geospatial services, guiding our clients from initial strategic consultation through to project implementation and long-term support.
          </p>
          <div className="industry__container">
            <div className="industry-verticals-grid">
              {/* Information Technology */}
              <div className="industry-vertical-card" onClick={() => handleNavClick("information-technology")}>
                <div className="industry-header it-header">
                  <h4>Information Technology</h4>
                </div>
                <div className="industry-vertical-card__content">
                  <div className="card-divider"></div>
                  <p className="industry-vertical-card__description">
                    Leveraging geospatial tech to enhance IT infrastructure, optimize centers, and more.
                  </p>
                  <button className="read-more">Read More</button>
                </div>
              </div>

              {/* GIS */}
              <div className="industry-vertical-card" onClick={() => handleNavClick("gis-services")}>
                <div className="industry-header gis-header">
                  <h4>GIS and Data Services</h4>
                </div>
                <div className="industry-vertical-card__content">
                  <div className="card-divider"></div>
                  <p className="industry-vertical-card__description">
                    Comprehensive Geographic Information Systems solutions.
                  </p>
                  <button className="read-more">Read More</button>
                </div>
              </div>

              {/* Agriculture */}
              <div className="industry-vertical-card" onClick={() => handleNavClick("agriculture")}>
                <div className="industry-header agriculture-header">
                  <h4>Agriculture</h4>
                </div>
                <div className="industry-vertical-card__content">
                  <div className="card-divider"></div>
                  <p className="industry-vertical-card__description">
                    Precision ag solutions with satellite imagery and GIS.
                  </p>
                  <button className="read-more">Read More</button>
                </div>
              </div>

              {/* Environment */}
              <div className="industry-vertical-card" onClick={() => handleNavClick("environment")}>
                <div className="industry-header environment-header">
                  <h4>Environment</h4>
                </div>
                <div className="industry-vertical-card__content">
                  <div className="card-divider"></div>
                  <p className="industry-vertical-card__description">
                    Environmental management and monitoring solutions.
                  </p>
                  <button className="read-more">Read More</button>
                </div>
              </div>

              {/* Health */}
              <div className="industry-vertical-card" onClick={() => handleNavClick("health")}>
                <div className="industry-header health-header">
                  <h4>Health</h4>
                </div>
                <div className="industry-vertical-card__content">
                  <div className="card-divider"></div>
                  <p className="industry-vertical-card__description">
                    Health GIS applications for disease mapping and analytics.
                  </p>
                  <button className="read-more">Read More</button>
                </div>
              </div>

              {/* Education & Research */}
              <div className="industry-vertical-card" onClick={() => handleNavClick("education-research")}>
                <div className="industry-header education-header">
                  <h4>Education & Research</h4>
                </div>
                <div className="industry-vertical-card__content">
                  <div className="card-divider"></div>
                  <p className="industry-vertical-card__description">
                    Educational and research support with geospatial technology.
                  </p>
                  <button className="read-more">Read More</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}


export default ServicesLandingPage;